import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
import BryxColors from "../types/theme";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxTypography from "./BryxTypography";
import { orFragment } from "@bryxinc/ts-utils";
const BryxTooltipIcon = styled((props) => {
    const cleanProps = { ...props, icon: undefined };
    return (_jsx(Tooltip, { ...cleanProps, disableInteractive: true, arrow: true, componentsProps: {
            tooltip: {
                sx: {
                    marginTop: "0 !important",
                },
            },
        }, children: _jsxs(IconButton, { disableRipple: true, children: [_jsx(BryxIcon, { iconName: props.icon, lgIconSize: true, selected: props.selected }), orFragment(props.badge !== undefined && props.badge > 0, _jsx(BryxTypography, { variant: "h4", sx: { marginLeft: "4px" }, children: props.badge }))] }) }));
})(({ theme }) => {
    // styles live in the global theme in theme.ts
    return {
        "& *": {
            color: BryxColors.notify(theme.palette.mode, "inactive"),
            fill: BryxColors.notify(theme.palette.mode, "inactive"),
        },
    };
});
export default BryxTooltipIcon;
